





























































































  import {Mutation, State, Action, Getter} from "vuex-class";
import {Vue, Component} from 'vue-property-decorator';
import AdminPageInfo from './AdminPageInfo.vue';
import Axios from "axios";
import alzuhudLink, {toBase64} from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo
    }
})
export default class UserTicket extends Vue {
    // @ts-ignore
    @State adminUser: string;
    // @ts-ignore
    @State routes: string[];
    @State ticketId: number;
    @State userId: number;
    @Getter token: string;
    panelTitle: string = 'Ticket';
    // @ts-ignore
    @Mutation replaceRoute;
    @Mutation setTicketId: (id: number | null) => void;
    @Action snackIt: Function;

    ticketData: any = {
        subject: 'Packages',
        status: 'Answered',
        user: {
            name: 'Arnold Lang',
            userTicketText: 'Minim nulla occaecat ut esse do id. Veniam excepteur quis aute consectetur. Lorem aliquip reprehenderit voluptate Lorem deserunt pariatur velit cupidatat eiusmod ea. Excepteur voluptate enim proident reprehenderit incididunt consequat ullamco qui aliquip aute eiusmod. Et laboris fugiat commodo et irure do sit. Ipsum proident mollit tempor ullamco nostrud tempor. Labore exercitation occaecat fugiat ut mollit incididunt eu labore duis quis. Adipisicing minim qui nisi esse occaecat mollit magna labore proident tempor. Ea elit occaecat et nostrud sint deserunt incididunt amet dolore excepteur duis ex laboris. Consequat ex aute esse incididunt laboris in. Labore dolor ullamco cupidatat id non. In officia veniam proident do quis do amet ea cillum ut.',
            userTicketTime: '12:35 PM',
            userTicketDate: '22.10.2019'
        },
        responder: {
            name: 'Jasmine Andrews',
            responderTicketText: 'Mollit pariatur ipsum consectetur eu deserunt qui amet voluptate. Tempor proident duis magna qui et quis consequat voluptate qui quis. Dolore sunt aliqua et anim nisi.',
            responderTicketTime: '12:35 PM',
            responderTicketDate: '22.10.2019'
        }
    };
    message: string = '';
    file: File | null;

    selectFile() {
      const el = document.getElementById('select-file');
      if (el !== null)
        el.click();
    }

    async mounted () {
      this.replaceRoute(['Support', 'My Tickets']);
      try {
        const response = await Axios.get(`http://${alzuhudLink}:8080/api/tickets/sections/${this.ticketId}`, {
          params: {
            token: this.token,
          }
        });

        console.log(response.data);
        this.ticketData = {
          subject: response.data.ticket.subject,
          status: response.data.ticket.status,
          tickets: [
            response.data.ticket,
            ...response.data.sections.data.reverse(),
          ]
        };
      } catch (e) {

      }

      const chat = document.getElementById('chatContainer');
      setTimeout(() => {
          if (!!chat)
              chat.scrollTop = chat.scrollHeight;
      }, 10);
    }

    getTime(datestr: string): string {
      const date = new Date(datestr);
      const now = new Date();
      const newDate = new Date(date.getTime() - (now.getTimezoneOffset() * 60000));
      return newDate.toLocaleTimeString('en-US', {
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
      });
    }

    getDate(datestr: string): string {
      const date = new Date(datestr);
      const now = new Date();
      const newDate = new Date(date.getTime() - (now.getTimezoneOffset() * 60000));
      return newDate.toLocaleDateString('en-US', {

      });
    }

    beforeDestroy() {
      this.setTicketId(null);
    }

    async sendTicket() {
      const img = !!this.file ? await toBase64(this.file): '';
      try {
        const response = await Axios.post(`http://${alzuhudLink}:8080/api/tickets/answer/${this.ticketId}`, {
          body: this.message,
          ticket_img: img,
          token: this.token,
        });
        const response2 = await Axios.get(`http://${alzuhudLink}:8080/api/tickets/sections/${this.ticketId}`, {
          params: {
            token: this.token,
          }
        });
        this.ticketData = {
          subject: response2.data.ticket.subject,
          status: response2.data.ticket.status,
          tickets: [
            response2.data.ticket,
            ...response2.data.sections.data.reverse(),
          ]
        };
        this.snackIt({
          message: 'Ticket Added',
          color: 'success',
          snackbar: true,
        });


      } catch (e) {
        this.snackIt({
          message: 'Failed to Add Ticket',
          color: 'error',
          snackbar: true,
        });
      } finally {
        this.message = '';
          const chat = document.getElementById('chatContainer');
          setTimeout(() => {
              if (!!chat)
                  chat.scrollTop = chat.scrollHeight;
          }, 10);
      }


    }
}
